import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function Demo() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try {
        const { data } = await api.post("/demo/login");
        if (data.token) localStorage.setItem("token", data.token);
        await refreshUser();
        navigate("/home", { replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, refreshUser]);

  return (
    <div className="min-h-screen bg-cream grain flex flex-col items-center justify-center gap-4">
      <img src="/logo.png" alt="Write My Story" className="h-16 w-16 object-contain" />
      <Loader2 className="animate-spin text-teal" size={28} />
      <p className="text-subtle text-sm">Opening the demo…</p>
    </div>
  );
}
